import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';
import { Button } from '@dnb/eufemia';
import IncidentViewer from '../components/incident-viewer/IncidentViewer';
import { chevron_left as ChevronLeft } from '@dnb/eufemia/icons';
import './incidents.css';

export default function ArchivePage({ incidents = [] }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine if we're on the business tab or personal tab
  const isBusiness = location.pathname.startsWith('/business');
  const incidentsRoute = isBusiness ? '/business/incidents' : '/incidents';

  // Add a check to ensure incidents is an array
  if (!incidents) {
    return (
      <main className="p_incidents-page" role="main">
        <div className="dnb-center-content">
          <p>Loading archived incidents...</p>
        </div>
      </main>
    );
  }

  try {
    return (
      <main className="p_incidents-page" role="main">
        <div className="dnb-center-content">
          <div className="incidents-header">
            <Button 
              className="back-button" 
              text={t('Back')} 
              variant="secondary"
              size="medium"
              icon={ChevronLeft}
              icon_position="left"
              onClick={() => navigate(incidentsRoute)}
            />
          </div>
          
          <h1 className="incidents-page-title">
            {t('Archive')}
          </h1>

          <IncidentViewer 
            incidents={incidents}
            filterType="historic"
          />
        </div>
      </main>
    );
  } catch (error) {
    console.error('ArchivePage render error:', error);
    return (
      <main className="p_incidents-page" role="main">
        <div className="dnb-center-content">
          <p>Error loading archive page: {error.message}</p>
        </div>
      </main>
    );
  }
}

ArchivePage.propTypes = {
  incidents: PropTypes.array,
};
